import { authHeader } from '../_helpers';
import { history } from '../_helpers';
// import React, {useContext} from 'react'
// import UserContext from '../context/context';
// import StateManager from 'react-select';

export const userService = {
    login,
    checkInfo,
    toCandidate,
    tokenLogin,
    logout,
    register,
    getAll,
    getById,
    update,
    delete: _delete,
    getUser,
};

// const local_link = 'http://localhost:8000'
const temp_link = "http://localhost:8000"
const local_link = 'https://qurator.co.kr'

// const aws_link = 'http://ec2-15-164-225-20.ap-northeast-2.compute.amazonaws.com:8080'

function login(email, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'email': email, 'password': password })
    };

    // return fetch(`/users/authenticate`, requestOptions)
    return fetch(local_link+ '/api-token-auth/', requestOptions)
        .then(
            handleResponse
        )
        .then(user => {
            
            console.log(user)
            
            localStorage.setItem('user', JSON.stringify(user));
            
            localStorage.setItem('email', email);

            return user;
        });
}
function toCandidate(token){

    return fetch(local_link + "/user/whoru/", {
      method: 'POST',
      headers: {Authorization: `JWT ${token}`},
      body: JSON.stringify({
        "is_candidate": true
      })
    })
    .then(response => response.json())
    .then(json=>{
        let newobj
        console.log(json)
        newobj = {
            token: token,
            user:{
                pk: json.id,
                email: json.email,
                username: json.email

            }
        }
        localStorage.setItem('user', JSON.stringify(newobj))
    })
    
}

function checkInfo(token){
    const requestOptions = {
        method: 'GET',
        headers: {Authorization: `JWT ${token}`},
    }
    console.log(requestOptions)
    return fetch (local_link + '/user/alldata/' , requestOptions)
    .then(
        response=>response.json()
        )
    // .then(json=>{
    //     console.log(json)
    //     console.log(json["is_headhunter"])
    // })
}

// const [state, actions] = useContext(UserContext)

function tokenLogin(e, token, index){
    // let headers = new Headers();
    // headers.set('Authorization', 'Basic ' + btoa("admin" + ":" + "obe1234"));
    // fetch(url, {method:'GET', headers: headers,})
    const requestOptions = {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            // 'Authroization': '',
            },
            body: JSON.stringify({"access_token": token})
    }
    // console.log(e)
    // console.log(token)
    let social_link = ''
    // console.log(state)

    if (index === 'facebook'){social_link = '/user/rest-auth/facebook/'}
    else if(index === 'google'){social_link = '/user/rest-auth/google/'}

    // console.log(local_link + social_link)
    
    return fetch (local_link + social_link, requestOptions)
    .then(
        handleResponse
        )
    .then(user => {
        console.log(user)

        // actions.setToken(JSON.stringify(user).token)
        
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('email', e.profileObj.email)
        console.log(localStorage)
        

        // console.log(user)
        // console.log("0")
        // console.log(localStorage.getItem('user'))
        return user;
    })
    .then(json =>{
        // console.log("1")
        // console.log(localStorage.getItem('user'))
        // console.log(json)
        // window.location.reload();
    })
}

function logout() {
    // remove user from local storage to log user out
    console.log("LOGOUT 주우우우우웅")
    localStorage.removeItem('user');
    localStorage.removeItem('email');
    localStorage.clear();
    
}

function getAll() {
    // const requestOptions = {
    //     method: 'GET',
    //     headers: authHeader()
    // };

    // console.log(authHeader())
    if(localStorage.getItem('user')){
        return (
            fetch (local_link + '/api-token-verify/', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({"token": JSON.parse(localStorage.getItem('user')).token})
            })
            
            .then(res => {
                res.json()
                // if(!res.ok){
                //     localStorage.clear()
                //     logout()
                // }
            }
                )
            .then(json =>{
            })
            
        )
    }else{
        return (
            fetch (local_link + '/api-token-verify/', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: '',
            })
            
            .then(res => {
                res.json()
                if(!res.ok){
                    localStorage.clear()
                    logout()
                }
            }
                )
            .then(json =>{
            })
            
        )
    }
    
    //   fetch(local_link + `/user/current_user/`, requestOptions).then(handleResponse);
}

function getUser(){
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(local_link + '/user/current_user/', requestOptions)
            .then(res => res.json())
            .then(json =>{
                console.log(json)
                // localStorage.setItem('email', json.email);
            });
}


function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`/users/${id}`, requestOptions).then(handleResponse);
}

function register(user) {
    console.log(user)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(local_link + `/user/users/`, requestOptions).then(handleResponse);
    // return fetch(`http://localhost:8000/user/users/`, requestOptions).then(handleResponse);
}

function update(user) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`/users/${user.id}`, requestOptions).then(handleResponse);;
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`/users/${id}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        console.log(data)
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload(true);
            }else if (data === 'EXIST'){
                history.push('/login')
                alert("이미 계정이 있는데?")
            }
            else{
                alert("error")
            }

            const error = (data && data.message) || response.statusText;
            
            // console.log(error)
            return Promise.reject(error);
        }

        return data;
    });
}